export default "__VITE_ASSET__BVi59ZTt__"